import { useContext } from "react";
import config from "../../../config.json";
import MapContext from "../MapContext";
import MapControlButton from "./MapControlButton";

const PhotoWMSControl = () => {
  const { map } = useContext(MapContext);

  const handleClick = () => {
    const center = map.getView().getCenter();
    const url = `${config.FOTOWMS_URL}${center[0]},${center[1]}`; 
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return <MapControlButton
    controlName="photo-wms"
    controlActive={false}
    icon="landscape"
    onClick={handleClick}/>;
};

export default PhotoWMSControl;